import ExtendBaseConfigurator from"base_configurator";export default ExtendBaseConfigurator({name:"k1element",props:["isEditing","imgEditing","img","posSlot","isDisabled","selectable"],methods:{emitClick:function emitClick(){this.$emit("click")}},computed:{compIsEditing:function compIsEditing(){return!!this.isEditing},compIsDisabled:function compIsDisabled(){return!!this.isDisabled},compSlot:function compSlot(){return this.posSlot}}});


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./app/components/elements/K1Element.vue
// module id = 251
// module chunks = 0